import { Box } from "@mui/material";
import React from "react";
import { HeaderText } from "../../shared/text/HeaderText.styled";
import FullScreenDrawerLayout from "../../shared/layout/FullScreenDrawerLayout";
import { useDatasources } from "../../context/DatasourceContext";
import { useLoading } from "../../context/LoadingContext";
import { useDrawer } from "../../context/DrawerContext";
import EstimatesList from "./estimate/EstimatesList";
import GcgrList from "./gcgr/GcgrList";
import ContractingPreview from "./contracting/ContractingPreview";
import CostModelList from "./costModel/CostModelList";
import { EDIPHI_DATASOURCE_META, EDIPHI_DATASOURCE_ORDER } from "./meta";
import TextIconButton from "../../shared/buttons/TextIconButton";
import { DATASOURCE_TYPE_LABEL } from "../../constants";
import { ediphiPalette } from "../../styles/colors";

const EdiphiDatasourceDrawer = () => {
  const { hasDatasource } = useDatasources();
  const { globalLoading } = useLoading();
  const { isOpen, mode, selection: selectedDatasourceType, select, close } = useDrawer("ediphi");

  const renderDatasourceList = () => {
    switch (selectedDatasourceType) {
      case "estimate":
        return <EstimatesList />;
      case "gcgr":
        return <GcgrList />;
      case "contracting":
        return <ContractingPreview />;
      case "cost-model":
        return <CostModelList />;
      default:
        return null;
    }
  };

  const generateDrawerTitle = () => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <Box component="img" src="assets/ediphi_logo.svg" alt="" aria-hidden sx={{ width: "16px", height: "16px" }} />
      <HeaderText>
        {mode === "edit" && selectedDatasourceType
          ? `Update ${EDIPHI_DATASOURCE_META[selectedDatasourceType].label}`
          : "Add Ediphi Data Source"}
      </HeaderText>
    </Box>
  );

  return (
    <>
      <FullScreenDrawerLayout isDrawerOpen={isOpen} onDrawerClose={close} drawerTitle={generateDrawerTitle()}>
        <Box sx={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}>
          {mode === "add" && (
            <Box
              role="group"
              aria-label={DATASOURCE_TYPE_LABEL}
              sx={{
                p: 2,
                flexShrink: 0,
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: 0.5,
                borderBottom: `1px solid ${ediphiPalette.borderDivider}`,
              }}
            >
              {EDIPHI_DATASOURCE_ORDER.map((type) => (
                <TextIconButton
                  key={type}
                  isSelected={selectedDatasourceType === type}
                  icon={EDIPHI_DATASOURCE_META[type].icon}
                  text={EDIPHI_DATASOURCE_META[type].label}
                  onClick={() => select(type)}
                  // The drawer stays open for the whole load — closeDrawer runs after it — so the
                  // tiles have to go unavailable or the pick stays live behind the progress dialog.
                  disabled={hasDatasource("ediphi", type) || globalLoading}
                />
              ))}
            </Box>
          )}
          <Box sx={{ p: 2, flex: 1, minHeight: 0, display: "flex", flexDirection: "column" }}>
            {selectedDatasourceType ? renderDatasourceList() : null}
          </Box>
        </Box>
      </FullScreenDrawerLayout>
    </>
  );
};

export default EdiphiDatasourceDrawer;
